@if (isPremiumActive()) {
    {{ 'toolbar.premium_state_demo_active' | translate }} {{ 'toolbar.premium_state_demo_expires_at' | translate:{date: localeDate()} }} <button (click)="expandPremiumClick($event)">{{ 'toolbar.premium_state_expand' | translate }}</button>
} @else if (isLicenceExpired()) {
    {{ 'toolbar.premium_state_licence_expired' | translate }}
}